var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.useRouterLink)?_c('RouterLink',{staticClass:"ae-link",attrs:{"to":_vm.to}},[_vm._t("default")],2):_c('a',{staticClass:"ae-link",attrs:{"href":_vm.to,"target":_vm.target},on:{"click":_vm.clickHandler}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }